import script from "./NewAboutUsPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAboutUsPage2.vue?vue&type=script&setup=true&lang=js"

import "./NewAboutUsPage2.vue?vue&type=style&index=0&id=7e9a71fa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9a71fa"]])

export default __exports__